import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './AdminContainer.module.css';

const AdminContainer = ({ type, children }) => {
    if(type!= 'Admin' && type!='Breathe-Admin') {
        return (
            <div className={styles['restricted']}>Restricted area !</div>
        )
    }
    return (
        <>{children}</>
    );
};

AdminContainer.propTypes = {
    type: PropTypes.string,
    children: PropTypes.node
};

const mapStateToProps = state => ({
    type: state.auth && state.auth.user ? state.auth.user.type : null
});

export default connect(mapStateToProps, {})(AdminContainer);
